import React from 'react';
import { useField } from '@kuzmycz/react-form-ula';
import { Label } from '../uielements';
import { CheckBox } from '../../services/settings/appStyle/global.style';

const CheckBoxField = ({ name, checked, isRed, ...rest }) => {
  const fieldContext = useField({ ...rest, name, type: 'checkbox' });
  const { error } = fieldContext.errorProps;

  return (
    <>
      <CheckBox
        color="primary"
        name={name}
        {...rest}
        {...fieldContext.fieldProps}
        checked={checked}
        isRed={isRed}
      />
      <Label color="error">{error}</Label>
    </>
  );
};

export default CheckBoxField;
